module.exports = __webpack_public_path__ + "assets/12838d0b2241a468c167356f91a31af8.png";